<template>
<v-row 
    dense
    v-show="showLine()"
>    
        <v-col class="flex-grow-0 align-self-center left_icon_column">
            <v-icon
                :disabled="disabled"
            >
                {{left_icon}}
            </v-icon>
        </v-col>

        <v-col>

            <m-select-timezone
                v-if="timezone"
                :value="value"
                @input="updateValue"
            />

            <v-select
                v-else-if="multiselect"
                dense
                multiple
                :label="label"
                :items="items"
                :value="value"
                v-on:change="updateValue"
            />

            <v-select
                v-else-if="select"
                dense
                :label="label"
                :items="items"
                :value="value"
                v-on:change="updateValue"
            />

            <v-text-field 
                v-else
                dense 
                :label="label" 
                :value="value"
                @input="updateValue"
                :rules="validation_rules"
                :hint="hint"
                validate-on-blur
                :disabled="disabled"
                :autofocus="autofocus"
                :type="text_field_type"
                autocomplete="off"
            />
            
        </v-col>

        <v-col 
            class="flex-grow-0 align-self-center right_icon_column"
            v-if="!no_right_column"
        >
            <v-icon 
                v-show="show_delete"
                v-on:click="onDelete"
                :disabled="disabled"
            >
                mdi-close-circle-outline
            </v-icon>
            
            <v-icon 
                v-show="show_add"
                v-on:click="onAdd"
            >
                mdi-plus-circle-outline
            </v-icon>
        </v-col>
</v-row>
</template>

<script>
const validate = require('@/js/validate.js'); 

export default {
    props: {
        value: {
            type: [String, Array],
            default: function() { return null; }
        },

        left_icon: {
            type: String,
            default: function() { return 'mdi-blank'; }
        },

        show_delete: {
            type: Boolean,
            default: function() { return false; }
        },

        show_add: {
            type: Boolean,
            default: function() { return false; }
        },

        label: {
            type: String,
            default: function() { return 'Label'; }
        },

        disabled: {
            type: Boolean,
            default: function() { return false; }
        },

        hint: {
            type: String,
            default: function() { return null; }
        },

        phone_number: {
            type: Boolean,
            default: function() { return false; }
        },

        timezone: {
            type: Boolean,
            default: function() { return false; }
        },

        email: {
            type: Boolean,
            default: function() { return false; }
        },

        us_date_with_optional_year: {
            type: Boolean,
            default: function() { return false; }
        },

        autofocus: {
            type: Boolean,
            default: function() { return false; }
        },

        required: {
            type: Boolean,
            default: function() { return false; }
        },

        no_right_column: {
            type: Boolean,
            default: function() { return false; }
        },

        hide_empty: 
        {
            type: Boolean,
            default: function() { return false; }
        },

        multiselect: 
        {
            type: Boolean,
            default: function() { return false; }
        },

        select: 
        {
            type: Boolean,
            default: function() { return false; }
        },

        items:
        {
            type: Array,
            default: function() { return null; }
        },

        password:
        {
            type: Boolean,
            default: function() { return false; }
        },
    },

    methods: {
        updateValue(value) 
        {
            this.$emit('input', value);    
        },

        onDelete()
        {
            this.$emit('on-delete');
        },

        onAdd()
        {
            this.$emit('on-add');
        },

        showLine()
        {
            if ( !this.hide_empty ) return true;

            if ( this.value == null ) return false;
            if ( this.value.trim().length == 0 ) return false;
            return true;
        }
    },

    computed: {
        validation_rules() 
        {
            let ret = [];

            if ( this.required )
                ret.push(validate.notBlank);

            if ( this.phone_number )
                ret.push(validate.isBlankOrUSPhoneNumber);

            if ( this.email )
                ret.push(validate.isBlankOrEmailAddress);

            if ( this.us_date_with_optional_year )
                ret.push(validate.isBlankOrValidUSDateWithOptionalYear);

            return ret;
        },

        text_field_type()
        {
            if ( this.password == true )
                return 'password';

            return null;
        },
    },
}
</script>

<style lang="scss" scoped>
.left_icon_column
{
    min-width: 40px;
}
.right_icon_column
{
    min-width: 60px;
}
</style>